import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../services/authService';
import { useAuth } from '../context/AuthContext';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    userType: 'individual',
    dealerName: '',
    address: {
      city: '',
      district: ''
    }
  });
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const { updateUser } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData({
        ...formData,
        [parent]: {
          ...formData[parent],
          [child]: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Şifreler eşleşmiyor');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      // confirmPassword'ü kaldır
      const userData = { ...formData };
      delete userData.confirmPassword;
      
      const result = await register(userData);
      
      if (result.success) {
        updateUser(result);
        navigate('/');
      } else {
        setError(result.message || 'Kayıt başarısız');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-md-center">
        <Col xs={12} md={8}>
          <h1 className="mb-4 text-center">Kayıt Ol</h1>
          
          {error && <Alert variant="danger">{error}</Alert>}
          
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Ad Soyad</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="name"
                    placeholder="Adınızı ve soyadınızı girin" 
                    value={formData.name} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control 
                    type="email" 
                    name="email"
                    placeholder="Email adresinizi girin" 
                    value={formData.email} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Şifre</Form.Label>
                  <Form.Control 
                    type="password" 
                    name="password"
                    placeholder="Şifrenizi girin" 
                    value={formData.password} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group className="mb-3" controlId="confirmPassword">
                  <Form.Label>Şifre Tekrar</Form.Label>
                  <Form.Control 
                    type="password" 
                    name="confirmPassword"
                    placeholder="Şifrenizi tekrar girin" 
                    value={formData.confirmPassword} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="phone">
                  <Form.Label>Telefon</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="phone"
                    placeholder="Telefon numaranızı girin" 
                    value={formData.phone} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group className="mb-3" controlId="userType">
                  <Form.Label>Üyelik Tipi</Form.Label>
                  <Form.Select 
                    name="userType"
                    value={formData.userType} 
                    onChange={handleChange}
                  >
                    <option value="individual">Bireysel</option>
                    <option value="dealer">Galeri/Bayi</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            
            {formData.userType === 'dealer' && (
              <Form.Group className="mb-3" controlId="dealerName">
                <Form.Label>Galeri/Bayi Adı</Form.Label>
                <Form.Control 
                  type="text" 
                  name="dealerName"
                  placeholder="Galeri veya bayi adını girin" 
                  value={formData.dealerName} 
                  onChange={handleChange}
                  required={formData.userType === 'dealer'}
                />
              </Form.Group>
            )}
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>Şehir</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="address.city"
                    placeholder="Şehir" 
                    value={formData.address.city} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group className="mb-3" controlId="district">
                  <Form.Label>İlçe</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="address.district"
                    placeholder="İlçe" 
                    value={formData.address.district} 
                    onChange={handleChange}
                    required 
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button 
              variant="primary" 
              type="submit" 
              className="w-100 mt-3" 
              disabled={loading}
            >
              {loading ? 'Kayıt yapılıyor...' : 'Kayıt Ol'}
            </Button>
            
            <div className="text-center mt-3">
              Zaten bir hesabınız var mı? <Link to="/login">Giriş yap</Link>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterPage;